﻿﻿import { IUser } from '../user';

export interface ITicketGroupUser {
    id: number;
    groupId: number;
    userId: number;
    isPrimary: boolean;
    user: IUser;
}
